import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Header from './styled/Header';
import Title from './styled/Title';
import Article from './styled/Article';
import Paragraph from './styled/Paragraph';

export default class OurProcess extends Component {


  static defaultProps = {};

  static contextType = ThemeContext;

  render() {
    const { className, heading, title, article1Heading, article1Text } = this.props;

    return (
      <Wrapper className={className}>
        <Header>
          <Heading theme={this.context}>{heading}</Heading>
          <Title theme={this.context}>{title}</Title>
        </Header>
        <Article>
          <Heading theme={this.context}>{article1Heading}</Heading>
          <Paragraph
            theme={this.context}
            smallMargin
            dangerouslySetInnerHTML={{ __html: article1Text.replace(/\n/g, '<br/>') }}
          />
        </Article>
      </Wrapper>
    );
  }
}
